export default __webpack_public_path__ + "static/media/cleanproVoucher1.f733fccf.png";